import  { TimelineLite }  from 'gsap';
import { init_bannerSliders } from "./scripts/banner-sliders";
import { init_forms } from "./scripts/form";
import { init_mobileMenu } from "./scripts/mobile-menu";
import { init_sidebarShopping } from "./scripts/sidebar-shopping";
import { init_searchBar } from "./scripts/search-bar";
import { init_header } from './scripts/header';
import { init_faq } from './scripts/faq';
import { init_sizeguide } from './scripts/sizeguide';
import { init_musicPlayer } from './scripts/music-player.js';
import { init_add_to_cart, init_edit_qty } from './scripts/cart';
import { init_product } from './scripts/product';
import { init_modal } from './scripts/modal';
import { init_horizontalSliders } from './scripts/horizontal-slider';
import { init_payment } from './scripts/payment';

import { init_videoPlayer } from './scripts/video-player.js';


document.addEventListener("DOMContentLoaded", function() {
    //console.log('Pakt.digital');
    init_bannerSliders();
    if( document.getElementById('header')){
        init_header();
        init_mobileMenu();
        init_searchBar();
        init_sidebarShopping();
    }
    if( document.getElementById('paymentForm')){
        init_payment();
    }
    init_faq();
    init_sidebarShopping();
    init_musicPlayer();
    init_forms();
    init_sizeguide();
    init_modal();
    init_horizontalSliders();
    // init_mobileMenu();
    // init_searchBar();
    // init_checkoutSteps();

    init_forms();
    init_add_to_cart();
    init_edit_qty();
    init_product();
    
    init_videoPlayer();
});



// WEBPACK FOOTER //
// ./resources/assets/js/app.js